import React, { useState, useEffect } from 'react';
import Timeline, { TodayMarker } from 'react-calendar-timeline'
import "react-calendar-timeline/dist/style.css";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import activityService from '../../services/ActivityService';
import Nav from '../../components/timeline/NavTimeline';
import LayerEdit from '../../components/timeline/LayerEdit';
import "./Timeline.css";

dayjs.locale('it')

const today = dayjs().valueOf();
const VISIBLE_RANGE = 1000 * 60 * 60 * 24 * 14;//14*2 giorni

export default function CalendarTimeline() {
    const [groupsData, setGroupsData] = useState([]);
    const [itemsData, setItemsData] = useState([]);
    const [visibleTimeStart, setVisibleTimeStart] = useState(today - VISIBLE_RANGE);
    const [visibleTimeEnd, setVisibleTimeEnd] = useState(today + VISIBLE_RANGE);
    const [initial, setInitial] = useState(false);
    const [linkedItems, setLinkedItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [activity, setActivity] = useState({});
    const [loadLayerEdit, setLoadLayerEdit] = useState(false);
    const [isLayerEdit, setIsLayerEdit] = useState(false);

    const handleTimeChange = (start, end, updateScrollCanvas) => {
        if (initial) {
            setVisibleTimeStart(start);
            setVisibleTimeEnd(end);
            updateScrollCanvas(start, end);
        }
        setInitial(true);
    };

    const normalizePayload = () => {
        return {
            months: [],
            status: [],
            mode: null,
            idClient: null
        };
    };

    const fetchActivity= async () => {
        try {
            const payload = normalizePayload();
            const res = await activityService.postFilter(payload);
            // Estrarre i dati specifici dalla struttura complessa di response.data
            const resultsData = res.data || [];
            setItemsData(resultsData); // Salva i risultati

        } catch (error) {
            console.error('Error fetching events', error);
        }
    };
    const fetchGroup= async () => {
        try {
            const payload = normalizePayload();
            const res = await activityService.postFilterGroup(payload);
            // Estrarre i dati specifici dalla struttura complessa di response.data
            const resultsData = res.data || [];
            setGroupsData(resultsData); // Salva i risultati

        } catch (error) {
            console.error('Error fetching events', error);
        }
    };
    useEffect(() => {
        fetchGroup();
        fetchActivity();
    }, []);

    const groups = groupsData.map((g, index) => ({
        id: g.id,
        title: g.title,
        macro: g.macro
    }))

    function hslColorFromId(id) {
        const hue = (id * 137.508) % 360; // golden angle
        return `hsl(${hue}, 65%, 55%)`;
    }
    const items = itemsData.map(a => ({
        id: a.id,
        group: a.groupId,
        title: a.title,
        start_time: new Date(a.startDate).getTime(),
        end_time: new Date(a.endDate).getTime(),
        notes: a.notes,
        link: a.referenceId,
        connection:a.connectionId,
        linkColor: hslColorFromId(a.referenceId),
        type: a.type,
        itemProps: {}
    }))

    const handleItemClick = (itemId) => {
        const mainItem = items.find(i => i.id === itemId);
        if (!mainItem) return;

        const related = items.filter(i => i.link === mainItem.link || i.connection === mainItem.link || i.link === mainItem.connection );

        setLinkedItems(related.map(i => i.id));
        setSelectedItem(mainItem);
    }

    const handleItemDoubleClick = (itemId) => {
        const mainItem = items.find(i => i.id === itemId);
        console.log(mainItem); //delete
        setLoadLayerEdit(true);
        setActivity(mainItem);
        setIsLayerEdit(!isLayerEdit);
    }

    const handleCanvasClick = () => {
        setLinkedItems([]);
        setSelectedItem(null);
        setLoadLayerEdit(false);
        setIsLayerEdit(!isLayerEdit);
    };

  	return (
  	<>
  	    <div className="row">
            <div className="col-md-12">
                {/* Nav Timeline */}
                <Nav />
            </div>
        </div>
        <div className="row">
            <Timeline
                groups={groups}
                items={items}
                canMove
                canResize="both"
                stackItems
                itemHeight={25}
                lineHeight={35}
                visibleTimeStart={visibleTimeStart}
                visibleTimeEnd={ visibleTimeEnd}
                onTimeChange={handleTimeChange}
                onItemSelect={(itemId, e, time) => handleItemClick(itemId)}
                onItemDoubleClick={(itemId) => handleItemDoubleClick(itemId)}
                onCanvasClick={() => handleCanvasClick()}
                timeSteps={{ day: 1 }}
                timeLabelFormat="D MMM"
                itemRenderer={({ item, itemContext, getItemProps }) => {
                    const { key, ...propsWithoutKey } = getItemProps({
                        style: {
                            background: item.linkColor,
                            display: linkedItems.length ? (linkedItems.includes(item.id) ? 'block' : 'none') : 'block',
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            transition: "opacity 0.2s ease",
                            boxShadow: linkedItems.includes(item.id)
                                ? "0 0 8px rgba(0,0,0,0.35)"
                                : "none",
                            zIndex: linkedItems.includes(item.id) ? 5 : 1,
                        },
                    });
                    return (
                        <div key={key} {...propsWithoutKey}>
                            <div style={{ padding: "0 6px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {item.title}
                            </div>
                        </div>
                    );
                }}
            >
                <TodayMarker>
                    {({ styles }) => (
                        <div
                            style={{
                                ...styles,
                                backgroundColor: '#fbec00',
                                width: '2px',
                            }}
                        />
                    )}
                </TodayMarker>
            </Timeline>
            {/* Slide */}
            { loadLayerEdit && (
                <LayerEdit show={isLayerEdit} onClose={handleItemDoubleClick} onFetchEdit={fetchActivity} activity={activity}/>
                )
            }
            {/* Slide */}
        </div>
    </>
	);
}